/*
 * 列表搜索的 mixin
 */
import request from './server'
import Cookie from "js-cookie";
import {mapMutations} from "vuex";

/* eslint-disable */
export const listSearch = {
  data () {
    return {
      // 加载中
      loading: false,
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO',
    }),
    /*
     * 发送请求
     */
    sendReq (params, callback) {
      request({
        method: params.method || 'POST',
        url: params.url,
        data: params.data || {},
        withCredentials : true,
        params: params.payload || {},
        headers: {
          'Content-type': params.contentType || 'application/json;charset=utf-8'
        }
      }).then((res) => {
        if (res.data.status===401){
          Cookie.remove('token');
          this.setUserInfo({});
        }
        if (res && res.data) {
          callback && callback(res.data)
        }
      }, (error) => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/mixin/searchMixin.js